// @ts-strict-ignore
import React from 'react'
import { Button, Icon, Input, Box as OuterWrapper } from '@node-space/ui-components'
import useFilterSearch from 'components/FilterBar/hooks/useFilterSearch'
import { sanitizeUserInput } from 'utils/utils'

const FilterSearch = ({ placeholder }: { placeholder: string }) => {
  const { setSearch, search } = useFilterSearch()

  const onSearchQueryChanged = e => {
    const { value } = e?.target ?? ''
    setSearch(sanitizeUserInput(value))
  }

  return (
    <OuterWrapper testId="filter-search-field-wrapper">
      <Input
        testId="filter-search-field"
        placeholderText={placeholder}
        onChange={onSearchQueryChanged}
        value={search}
        searchable
        iconPosition="right"
        IconButton={
          search && (
            <Button variant="ghost" onClick={() => setSearch('')} iconElement={<Icon name="X" />} />
          )
        }
      />
    </OuterWrapper>
  )
}

export default FilterSearch
